import React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import Wrapper from '@components/wrapper.styled';
import Text from '@components/text';
import { ImageProps } from '@components/image';
import { defaultTheme } from '@styles/theme.styled';
import getLinkConfig from '@helpers/get-link-config';
import Section from '@components/section';
import {
  GradientWrapper,
  LinkButton,
  Container,
  ImageContainer,
  Content,
  TextContent,
} from './tout.styled';

interface ToutProps {
  title?: string;
  subheading?: RichTextBlock[];
  image?: ImageProps;
  link?: {
    url?: string;
    uid?: string;
    target?: string;
  };
  linkLabel?: string;
  layoutType?: string;
  backgroundColor?: keyof typeof defaultTheme.backgroundColors;
}

const Tout = ({
  title,
  subheading = [],
  image,
  link,
  backgroundColor = 'white',
  linkLabel,
  layoutType = 'Row',
}: ToutProps): JSX.Element => {
  const hasImage: boolean = image?.url !== undefined && image?.url !== null && image?.url !== '';
  const isSubheadingExisting: boolean = subheading?.length > 0 && subheading[0].text !== '';
  const linkConfig = getLinkConfig(link);

  if (!title && !image && !isSubheadingExisting && !link) {
    return <></>;
  }

  return (
    <Section backgroundColor={backgroundColor}>
      <Wrapper>
        <GradientWrapper layoutType={layoutType}>
          <Container layoutType={layoutType}>
            {hasImage && (
              <ImageContainer
                url={image?.url}
                alt={image?.alt || ''}
                gatsbyImageData={image?.gatsbyImageData}
                objectFit="contain"
              />
            )}
            <Content hasImage={hasImage}>
              <TextContent>
                {title && (
                  <Text
                    type="title"
                    tag="h2"
                    fontSize="heading3"
                    stringText={title}
                    margin="none"
                  />
                )}

                {isSubheadingExisting && (
                  <Text
                    type="description"
                    fontSize="subheading"
                    richText={subheading}
                    fontColor="primary"
                  />
                )}
              </TextContent>

              {!!linkConfig.url && (
                <LinkButton
                  url={linkConfig.url}
                  type="button"
                  displayArrow
                  title={linkLabel || 'Request a Demo'}
                  isExternal={linkConfig.isExternal}
                  target={link?.target || '_self'}
                />
              )}
            </Content>
          </Container>
        </GradientWrapper>
      </Wrapper>
    </Section>
  );
};

export default Tout;
